/*
 * @Author: huangzq
 * @Date: 2020-03-17 17:25:08
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-03-18 14:18:52
 * @Desc: 上传loading
*/
<template>
  <div class="progress-loading">
    <i class="el-icon-loading" />
    <p class="loading-tip">
      {{ tip }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ProgressLoading',
  props: {
    tip: {
      type: String,
      default: '上传中，请耐心等待'
    }
  }
}
</script>

<style lang='scss' scoped>
.progress-loading {
  text-align: center;

  .el-icon-loading {
    font-size: 70px;
    color: #009cff;
  }

  .loading-tip {
    margin-top: 15px;
    color: #262626;
    font-size: 13px;
  }
}
</style>
